export default __webpack_public_path__ + "static/media/img_dns_response-colorBkg.b280ce57.png";